export { default } from 'ember-cli-clipboard/components/copy-button';
